module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "slider"
  }, [_c('ul', {
    staticClass: "slides"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/104.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption center-align"
  }, [_c('h3', [_vm._v("Sala de Entretenimento!")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/041.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption left-align"
  }, [_c('h3', [_vm._v("WIFI em todo Hotel!")])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/021.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption left-align"
  }, [_c('h3', [_vm._v("Café da Manhã!")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m12 l12"
  }, [_c('div', {
    staticClass: "card z-depth-2 hoverable"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("Serviços:")]), _vm._v(" "), _c('p', [_vm._v("Oferecemos o melhor para o seu conforto !")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
    staticClass: "tiny ion-ios-pizza"
  }), _vm._v(" Lanches 24 horas")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "tiny ion-ios-cafe"
  }), _vm._v(" Café da Manhã")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "tiny ion-ios-car"
  }), _vm._v(" Estacionamento aéreo e subterrâneo")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "tiny ion-ios-water"
  }), _vm._v(" Lavanderia")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "tiny ion-ios-wifi"
  }), _vm._v(" Wi-Fi gratuito")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "tiny ion-ios-alarm"
  }), _vm._v(" Despertador")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "tiny ion-logo-windows"
  }), _vm._v(" Sala de Entretenimento com computador e tv")])])])])])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a42c729", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a42c729"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/servicos/servicos.vue
// module id = 83
// module chunks = 0